import React from "react";
import { Select } from "antd";
const { Option } = Select;

export default function AssetBulkUploadBody({
  setSelectedStore,
  selectedStore,
  assetsList,
}) {
  return (
    <div className="col-md-4">
      <label htmlFor="asset-store">Store</label>
      <Select
        id="asset-store"
        className="form-control"
        showSearch
        onChange={(value) => {
          setSelectedStore({
            storeId: value,
          });
        }}
        value={selectedStore.storeId}
        placeholder="-- Please Select --"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {" "}
        {assetsList?.StoreList?.map((item) => (
          <Option key={item.store_id} value={item.store_id}>
            {item.store_name}
          </Option>
        ))}
      </Select>
    </div>
  );
}
